var r=[],p=function(p,n){r.push(p);var o=n(p);return r.pop(),o};export{p as provide};
//# sourceMappingURL=serviceScope.js.map
